import React from 'react'
import { Button, Form, Input, Modal, Icon } from 'semantic-ui-react'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import Single from '../../../componentes/Single'
import EditarHerramienta from '../../Productos/Componentes/editarHerramienta'
import EditarProveedor from '../../Productos/Componentes/editarProveedor'
import { formatStrInput } from '../../../formatInput'
import SubmitButton from '../../../componentes/submitButton/submitButton'
import {Table} from 'semantic-ui-react'
import { AuthContext } from '../../../Auth'
import ProveedorImport from '../../../componentes/ProveedorImport/ProveedorImport'
import FormStyles from '../../../componentes/forms/form.module.css'
import CatalogImport from '../../../componentes/CatalogImport/CatalogImport'
import {getCompanyCollection} from '../../../firebase'

const getVisibleData = (data, search) => {
    const term = formatStrInput(search || '')
    if (!term) return data
    return data.filter(item => Object.values(item).some(value =>
        formatStrInput(String(value === undefined || value === null ? '' : value)).includes(term)
    ))
}

class Catalog extends React.Component {
    static contextType = AuthContext
    constructor(props) {
        super(props)
        this.state = {
            catalog: 'herramienta',
            search: '',
        }
    }
    handleClick = (name) => {
        this.setState({ catalog: name })
    }
    render() {
        return (
            <section>
                <div className="secondnav" >
                    <button name='herramienta' className={`${this.state.catalog === "herramienta"?"active":null}`} onClick={() => { this.handleClick('herramienta') }}>Herramienta</button>
                    <button name='marca' className={`${this.state.catalog === "marca"?"active":null}`} onClick={() => { this.handleClick('marca') }}>Marca</button>
                    <button name='proveedor' className={`${this.state.catalog === "proveedor"?"active":null}`} onClick={() => { this.handleClick('proveedor') }}>Proveedor</button>
                    <Input className='secondnavSearch' icon='search' placeholder='Buscar...' value={this.state.search} onChange={(e, {value}) => this.setState({search: value})} />
                </div>
                <Herramienta search={this.state.search} hidden={this.state.catalog !== 'herramienta'} currentUser={this.context.currentUser} />
                <Marca search={this.state.search} hidden={this.state.catalog !== 'marca'} currentUser={this.context.currentUser} />
                <Proveedor search={this.state.search} hidden={this.state.catalog !== 'proveedor'} currentUser={this.context.currentUser} />
            </section>
        )
    }
}
class Marca extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            doc: {
                nombre: ''
            },
            data: [],
            filteredData: [],
            message: '',
            useModal: false,
        }
        this.currentUser = props.currentUser
        this.collection = 'Marcas'
        this.database = null
    }
    handleChange = (e, { name, value }) => {
        this.setState({
            doc: {
                [name]: value
            }
        })
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.doc.nombre !== prevState.doc.nombre) {
            this.filter()
        }
    }
    async componentDidMount() {
        this.database = await getCompanyCollection(this.collection)
        this.getData()
    }
    getData = () => {
        this.database.orderBy('nombre', 'asc').onSnapshot(snap => {
            const data = []
            for (let i = 0; i < snap.docs.length; i++) {
                data.push({
                    id: snap.docs[i].id,
                    ...snap.docs[i].data(),
                })
            }
            this.setState({ data, filteredData: data })
        })
    }
    handleBlur = (e) => {
        const name = e.target.name
        const formatedStr = formatStrInput(this.state.doc[name])
        const doc = { ...this.state.doc }
        doc[name] = formatedStr
        this.setState({ doc })
    }
    filter = async () => {
        const inputName = formatStrInput(this.state.doc.nombre)
        const filteredData = []
        for (let i = 0; i < this.state.data.length; i++) {
            const inDataName = formatStrInput(this.state.data[i].nombre)
            if (inDataName.indexOf(inputName) > -1) {
                filteredData.push(this.state.data[i])
            }
        }
        this.setState({ filteredData })
    }
    validateSubmit = async () => {
        if (this.state.doc.nombre === '') {
            this.setState({ message: 'Llene todos los campos' })
            return null
        }
        const snap = await this.database
            .where('nombre', '==', formatStrInput(this.state.doc.nombre))
            .get()
        if (snap.size > 0) {
            this.setState({ message: 'Elemento repetido' })
            return false
        }
        return true
    }
    handleSubmit = async () => {
        try {
            if (!await this.validateSubmit()) return null
            let doc = { ...this.state.doc }
            doc.nombre = formatStrInput(doc.nombre)
            doc.tipo = "herramientas"
            await this.database.add(doc)
            this.setState({
                message: 'Tipo agregado con éxito',
                doc: {
                    nombre: ''
                },
            })
        }
        catch (error) {
            this.setState({
                message: 'Ocurrió un error'
            })
            console.log(error)
        }
        this.changeUsModal(false)
    }
    admin =(element)=>{
		if (this.currentUser.rol === "admin" || this.currentUser.rol === "warehouseAdmin"){
			return(
                <button className='borrar' onClick={
                    () =>{
                        const confirmBox = window.confirm(`Esta accion no se puede revertir!!! Desea borrar ${element.nombre} ?`)
                        if (confirmBox === true) {this.borrar(element.id)}
                    }
                    }><Icon name='trash alternate' />
                </button>
			)
		}
	}
    borrar= async (id) => {
		this.database.doc(id).delete().then(() => {
            console.log("Borrado");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
	}
    modalAgregar = () => (
		<Modal
			className={FormStyles.modal}
			onClose={() => this.changeUsModal(false)}
			onOpen={() => this.changeUsModal(true)}
			open={this.state.useModal}
			trigger={<button><Icon name='plus' />Nuevo</button>}>
			<Modal.Header>Agregar nueva marca</Modal.Header>
			<Modal.Content>
            <Form autoComplete='off'>
                <Form.Field>
                    <Input required placeholder='Marca' onChange={this.handleChange} onBlur={this.handleBlur} name='nombre' value={this.state.doc.nombre} />
                </Form.Field>
                <div className={FormStyles.actions}>
                    <CatalogImport
                        label='Marcas'
                        template='plantilla-marcas.xlsx'
                        headers={['Nombre']}
                        items={this.state.data}
                        getKey={item => item.nombre}
                        mapRow={row => {
                            const nombre = formatStrInput(row[0])
                            if(!nombre) throw new Error('Nombre requerido')
                            return {nombre, tipo: 'herramientas'}
                        }}
                        addItem={item => this.database.add(item)}
                    />
                    <Button type='button' basic onClick={() => this.changeUsModal(false)}>Cancelar</Button>
                    <SubmitButton handleSubmit={this.handleSubmit}>Agregar</SubmitButton>
                </div>
            </Form>
                <p>{this.state.message}</p>
			</Modal.Content>
		</Modal>
	)
	changeUsModal=(open)=>{
		this.setState({useModal:open})
	}
    render() {
        return (
            <section hidden={this.props.hidden}>
                <div className='filtros'>
                    <h3>Marca</h3>
                    <this.modalAgregar />
                </div>
                <p>{this.state.message}</p>
                <div>
                    {
                        getVisibleData(this.state.filteredData, this.props.search).map((element, i) =>
                        <div className='divrow'  key={i} >
                            <div className='contentLeft'>
                                {element.nombre}
                            </div>
                            <div className='borrar'>
                                {this.admin(element)} 
                            </div>
                        </div>
                        )
                    }
                </div>
            </section>
        )
    }
}
class Proveedor extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            nombre: '',
            telefono: '',
            correo: '',
            direccion: '',
            data: [],
            filteredData: [],
            message: '',
            useModal: false,
        }
        this.currentUser = props.currentUser
        this.collection = 'Proveedores'
        this.database = null
    }
    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    async componentDidMount() {
        this.database = await getCompanyCollection(this.collection)
        this.getData()
    }
    getData = () => {
        this.database.orderBy('nombre', 'asc').onSnapshot(snap => {
            const data = []
            for (let i = 0; i < snap.docs.length; i++) {
                data.push({
                    id: snap.docs[i].id,
                    ...snap.docs[i].data(),
                })
            }
            this.setState({ data, filteredData: data })
        })
    }
    filter = async () => {
        const inputName = formatStrInput(this.state.nombre)
        const filteredData = []
        for (let i = 0; i < this.state.data.length; i++) {
            const inDataName = formatStrInput(this.state.data[i].nombre)
            if (inDataName.indexOf(inputName) > -1) {
                filteredData.push(this.state.data[i])
            }
        }
        this.setState({ filteredData })
    }
    validateSubmit = async () => {
        if (this.state.nombre === '') {
            this.setState({ message: 'Llene todos los campos' })
            return null
        } else {
            this.setState({nombre:this.state.nombre.toUpperCase()})
        }
        const snap = await this.database
            .where('nombre', '==', this.state.nombre)
            .get()
        if (snap.size > 0) {
            this.setState({ message: 'Elemento repetido' })
            return false
        }
        return true
    }
    handleSubmit = async () => {
        try {
            if (!await this.validateSubmit()) return null
            await this.database.add(
                {nombre: this.state.nombre,
                telefono: this.state.telefono,
                correo: this.state.correo,
                direccion: this.state.direccion,
                tipo: "herramientas"
            }
            )
            this.setState({
                message: 'Tipo agregado con éxito',
                nombre: '',
                telefono: '',
                correo: '',
                direccion: '',
            })
            this.changeUsModal(false)
        }
        catch (error) {
            this.setState({
                message: 'Ocurrió un error'
            })
            console.log(error)
        }
        this.changeUsModal(false)
    }
    addProveedor = proveedor => this.database.add({
        ...proveedor,
        tipo: 'herramientas',
    })
    admin =(row)=>{
		if (this.currentUser.rol === "admin" || this.currentUser.rol === "warehouseAdmin"){
			return(
            <EditarProveedor
                data={row}
                tabla={this.collection}
            />
			)
		}
	}
    modalAgregar = () => (
		<Modal 
			onClose={() => this.changeUsModal(false)}
			onOpen={() => this.changeUsModal(true)}
			open={this.state.useModal}
			trigger={<button><Icon name='plus' />Nuevo</button>}>
			<Modal.Header>Agregar nuevo proveedor</Modal.Header>
			<Modal.Content>
            <Form className={FormStyles.form} autoComplete='off'>
                <Form.Field className={FormStyles.fieldRow} required>
                    <label className={FormStyles.fieldLabel}>Nombre</label>
                    <div className={FormStyles.fieldContent}>
                        <Input fluid required placeholder='Nombre del proveedor' onChange={this.handleChange} name='nombre' value={this.state.nombre} />
                    </div>
                </Form.Field>
                <Form.Field className={FormStyles.fieldRow}>
                    <label className={FormStyles.fieldLabel}>Teléfono</label>
                    <div className={FormStyles.fieldContent}>
                        <Input fluid type='tel' placeholder='Número telefónico' onChange={this.handleChange} name='telefono' value={this.state.telefono} />
                    </div>
                </Form.Field>
                <Form.Field className={FormStyles.fieldRow}>
                    <label className={FormStyles.fieldLabel}>Correo</label>
                    <div className={FormStyles.fieldContent}>
                        <Input fluid type='email' placeholder='correo@proveedor.com' onChange={this.handleChange} name='correo' value={this.state.correo} />
                    </div>
                </Form.Field>
                <Form.Field className={FormStyles.fieldRow}>
                    <label className={FormStyles.fieldLabel}>Dirección</label>
                    <div className={FormStyles.fieldContent}>
                        <Input fluid placeholder='Dirección del proveedor' onChange={this.handleChange} name='direccion' value={this.state.direccion} />
                    </div>
                </Form.Field>
                <div className={FormStyles.actions}>
                    <ProveedorImport proveedores={this.state.data} addProveedor={this.addProveedor} />
                    <Button type='button' basic onClick={() => this.changeUsModal(false)}>Cancelar</Button>
                    <SubmitButton handleSubmit={this.handleSubmit}>Agregar</SubmitButton>
                </div>
            </Form>
                <p>{this.state.message}</p>
			</Modal.Content>
		</Modal>
	)
	changeUsModal=(open)=>{
		this.setState({useModal:open})
	}
    render() {
        return (
            <section hidden={this.props.hidden}>
                <div className='filtros'>
                    <h3>Proveedor</h3>
                    <this.modalAgregar />
                </div>
                <p>{this.state.message}</p>
                <div  className="body tabla">
                    <table><tbody>
                        <tr>
                            <th>Proveedor</th>
                            <th>Telefono</th>
                            <th>Correo</th>
                            <th>Direccion</th>
                        </tr>
                        {getVisibleData(this.state.filteredData, this.props.search).map((row, i)=>{
                            return(
                                <Table.Row key={i}>
                                    <Table.Cell>{row.nombre}</Table.Cell>
                                    <Table.Cell>{row.telefono}</Table.Cell>
                                    <Table.Cell>{row.correo}</Table.Cell>
                                    <Table.Cell>{row.direccion}</Table.Cell>
                                    <Table.Cell>{this.admin(row)}</Table.Cell>
                                </Table.Row>
                            )
                        })}
                    </tbody></table>
                </div>
            </section>
        )
    }
}
class Herramienta extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            doc: {
                nombre: '',
                descripcion: '',
                marca: ''
            },
            update: {
                nombre: '',
                descripcion: '',
                marca: ''
            },
            data: [],
            filteredData: [],
            message: '',
            useModal: false,
        }
        this.currentUser = props.currentUser
        
        this.collection = 'Herramientas'
        this.database = null
    }
    async componentDidMount() {
        this.database = await getCompanyCollection(this.collection)
        this.getData()
    }
    getData = () => {
        this.database.orderBy('nombre', 'asc').onSnapshot(snap => {
            const data = []
            for (let i = 0; i < snap.docs.length; i++) {
                data.push({
                    id: snap.docs[i].id,
                    ...snap.docs[i].data(),
                })
            }
            this.setState({ data, filteredData: data })
        })
    }
    handleChange = async (e, { name, value }) => {
        const doc = { ...this.state.doc }
        doc[name] = formatStrInput(value)
        this.setState({ doc })
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.doc.nombre !== prevState.doc.nombre) {
            this.filter()
        }
    }
    handleBlur = (e) => {
        const name = e.target.name
        const formatedStr = formatStrInput(this.state.doc[name])
        const doc = { ...this.state.doc }
        doc[name] = formatedStr
        this.setState({ doc })
    }
    filter = async () => {
        const inputName = formatStrInput(this.state.doc.nombre)
        const filteredData = []
        for (let i = 0; i < this.state.data.length; i++) {
            const inDataName = formatStrInput(this.state.data[i].nombre)
            if (inDataName.indexOf(inputName) > -1) {
                filteredData.push(this.state.data[i])
            }
        }
        this.setState({ filteredData })
    }
    validateSubmit = async (data) => {
        const doc = data
        if (doc.nombre === '') {
            this.setState({ message: 'Nombre Obligatorio' })
            return false
        }
        const snap = await firebase
            .firestore()
            .collection(this.collection)
            .where('nombre', '==', formatStrInput(data.nombre))
            .get()
        if (snap.size > 0) {
            this.setState({ message: 'Ya existe ese Nombre' })
            return false
        }
        return true
    }
    handleSubmit = async () => {
        try {
            const validation = await this.validateSubmit(this.state.doc)
            if (!validation) {
                return null
            }
            let doc = { ...this.state.doc }
            doc.nombre = formatStrInput(doc.nombre)
            await firebase.firestore().collection(this.collection).add(doc)
            this.setState({
                message: 'Registro agregado con éxito',
                doc: {
                    nombre: '',
                    descripcion: '',
                    marca: ''
                },
            })
        }
        catch (error) {
            this.setState({
                message: 'Ocurrió un error'
            })
            console.log(error)
        }
        this.changeUsModal(false)
    }
    admin =(row)=>{
		if (this.currentUser.rol === "admin" || this.currentUser.rol === "warehouseAdmin"){
			return(
            <EditarHerramienta
                data={row}
                tabla={this.collection}
            />
			)
		}
	}
    modalAgregar = () => (
		<Modal
			className={FormStyles.modal}
			onClose={() => this.changeUsModal(false)}
			onOpen={() => this.changeUsModal(true)}
			open={this.state.useModal}
			trigger={<button><Icon name='plus' />Nuevo</button>}>
			<Modal.Header>Agregar herramienta</Modal.Header>
			<Modal.Content>
                <Form autoComplete='off'>
                    <Form.Field>
                        <Input placeholder="Nombre" 
                            onChange={this.handleChange} 
                            onBlur={this.handleBlur} name='nombre' 
                            value={this.state.doc.nombre} 
                        />
                    </Form.Field>
                    <Form.Field>
                        <Single
                            placeholder="Marca"
                            onChange={this.handleChange}
                            name='marca'
                            columna='nombre'
                            tabla='Marcas'
                            value={this.state.doc.marca}
                        />
                    </Form.Field>
                    <Form.Field>
                        <Input placeholder="Descripcion" 
                            onChange={this.handleChange} 
                            onBlur={this.handleBlur} name='descripcion' 
                            value={this.state.doc.descripcion} 
                        />
                    </Form.Field>
                    <div className={FormStyles.actions}>
                        <CatalogImport
                            label='Herramientas'
                            template='plantilla-herramientas.xlsx'
                            headers={['Nombre', 'Marca', 'Descripción']}
                            items={this.state.data}
                            getKey={item => item.nombre}
                            mapRow={row => {
                                const nombre = formatStrInput(row[0])
                                const marca = formatStrInput(row[1])
                                const descripcion = formatStrInput(row[2])
                                if(!nombre) throw new Error('Nombre requerido')
                                return {nombre, marca, descripcion}
                            }}
                            addItem={item => this.database.add(item)}
                        />
                        <Button type='button' basic onClick={() => this.changeUsModal(false)}>Cancelar</Button>
                        <SubmitButton handleSubmit={this.handleSubmit}>Agregar</SubmitButton>
                    </div>
                </Form>
                <p>{this.state.message}</p>
			</Modal.Content>
		</Modal>
	)
	changeUsModal=(open)=>{
		this.setState({useModal:open})
	}
    render() {
        return (
            <section hidden={this.props.hidden}>
                <div className='filtros'>
                    <h3>Agregar Herramienta</h3>
                    <this.modalAgregar />
                </div>
                <p>{this.state.message}</p>
                <div  className="body tabla">
				    <table><tbody>
                        <tr>
                            <th>Nombre</th>
                            <th>Descripcion</th>
                            <th>Marca</th>
                        </tr>
                        {getVisibleData(this.state.filteredData, this.props.search).map((row, i)=>{
                            return(
                                <Table.Row key={i}>
                                    <Table.Cell>{row.nombre}</Table.Cell>
                                    <Table.Cell>{row.descripcion}</Table.Cell>
                                    <Table.Cell>{row.marca}</Table.Cell>
                                    <Table.Cell>{this.admin(row)}</Table.Cell>
                                </Table.Row>
                            )
                        })}
                    </tbody></table>
			    </div>
            </section>
        )
    }
}

export default Catalog
